import state from './globalaction.state'
import mutations from './globalaction.mutations'
import actions from './globalaction.actions'

export default {
  state,
  mutations,
  actions
}
